///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/product-categories.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class PurchaseOrderProductCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected productCategories: ProductCategoriesCollection;
        protected productSubCategories: ProductSubCategoriesCollection;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.productCategories;
        }

        get totalSelectedCount(): number {
            return this.productSubCategories.value.length;
        }

        get totalParentSelectedCount(): number {
            return this.productCategories.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.productCategories = new ProductCategoriesCollection(this.model[this.properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.productSubCategories = new ProductSubCategoriesCollection(this.model[this.properties[1]], [], {
                criteria: {},
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.productSubCategories.setParentCollection(this.productCategories, ProductCategoriesToSubCategoriesStrategy);

            this.title = 'LABEL_PRODUCT_CATEGORY';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCT_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.productSubCategories.setWatchers(scope);
        }
    }
}